<template>
  <v-container class="mb-12">
    <TitleAppBar v-bind:title="'Agenda'" />

    <div v-if="festivalInFront" class="backgroundGrey mb-10">
      <v-container class="px-6 pb-10">
        <v-row align="center">
          <v-col cols="12" sm="6" class="px-10 d-none d-sm-block">
            <div
              class="absoluteImage"
            >
              <a 
                :to="{ name: 'festivalInfo'}"
                class='blue--text font-weight-medium font-italic'
              >
                <v-img height="400" :src="festival.acf.image"></v-img>
              </a>
            </div>
          </v-col>


          <v-col cols="12" sm="6" class="text-center text-sm-left pr-10">
            <h2 class="text-h2" v-text="'La ' + festival.acf.edition + 'eme édition de notre festival !'"></h2>
            <BlackLine />
            <p class="text-body-1 mt-3 mb-10">Du {{ festival.acf.start_date }} au {{ festival.acf.end_date }}</p>

            <v-btn v-if="ticketOpen" depressed rounded color="secondary" :href="ticketLink" class="mr-4">
              Réserver 
            </v-btn>

            <v-btn depressed outlined plain rounded :to="{ name: 'festivalProgram' }">
              La programmation
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <AgendaCard
      v-for="date in dates"
      :key="date.id"
      v-bind:title="date.title.rendered"
      v-bind:date="date.acf.date"
      v-bind:city="date.acf.choose_place === 'home' ? 'Bergerac' : date.acf.other_place.city"
      v-bind:place="date.acf.choose_place === 'home' ? 'Le Foyer du TROC' : date.acf.other_place.place_name"
      v-bind:postType="date.acf.event_source.formatted_value.post_type"
      v-bind:eventId="date.acf.event"
      v-bind:type="
        date.acf.event_source.formatted_value.post_type === 'event' ? 'evenement' : 'spectacle'
      "
    />
  </v-container>
</template>

<script>
import moment from "moment";
import AgendaCard from "../../../components/cards/agendaCard";
import { APIService } from "../../../APIService";
import TitleAppBar from "../../../components/titleAppBar";
const apiService = new APIService();

export default {
  name: "Agenda",

  components: {
    AgendaCard,
    TitleAppBar
  },

  data: () => ({
    dates: [],
    festivalInFront: false,
    festival: {},
    ticketOpen: false,
    ticketLink: ""
  }),

  mounted() {
    apiService.getAll("wp/v2/pages/1031").then(data => {
      this.festivalInFront = data.acf.festival_in_front
      if (data.acf.festival_in_front) {
        apiService.getAll("wp/v2/festival").then(data => {
          this.festival = data[0];
        })
        this.ticketOpen = data.acf.activate_billeterie
        this.ticketLink = data.acf.link_billetterie
      }
    })
    apiService.getAll("wp/v2/calendar").then(data => {
      let sortDataArray = data.sort((a, b) => {
        return moment(a.acf.date_source.formatted_value, 'DD/MM/YYYY HH:mm').diff(moment(b.acf.date_source.formatted_value, 'DD/MM/YYYY HH:mm'));
      })
      sortDataArray.forEach(element => {
        if (moment(element.acf.date_source.formatted_value, "DD/MM/YYYY HH:mm").isAfter(moment())) {
          this.dates.push(element)
        }
      });
    });
  }
};
</script>
